/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { SupportedLocale } from "../enums/componentEnums";

export const routesToHidNavBar = (company_id: string) => [
  "/dashboard/my-account",
  `/dashboard/senior-manager/sites/${company_id}`,
  `/dashboard/operations/sites/${company_id}`,
  `/dashboard/admin/devices/${company_id}`,
  // `/dashboard/admin/users/${company_id}`,
  `/dashboard/operations/activity-log/${company_id}`,
];

export const routesToHideFilter = (company_id: string) => [
  `/dashboard/admin/user-analytics/${company_id}`,
  `/dashboard/admin/user-analytics-detail/${company_id}`,
];
export const routesToShowSearch = [
  "/dashboard/operations/sites",
  "/dashboard/finance/transactions",
];
export const generateAccountInfo = (
  firstName: string,
  lastName: string,
  email: string,
  company: string
) => {
  return [
    {
      tag: "First Name",
      value: firstName,
    },
    {
      tag: "Last Name",
      value: lastName,
    },
    {
      tag: "Email",
      value: email,
    },
    {
      tag: "Company",
      value: company,
    },
  ];
};

export const siteData: {
  id: number;
  name: string;
  description: string;
  position: [number, number];
  link: string;
  isRed?: boolean;
}[] = [
  {
    id: 4,
    name: "C407",
    description: "MINISTERE DE LA SANTE",
    position: [6.365137, 2.462924],
    link: "/operations/dashboard/4",
    isRed: true,
  },
  {
    id: 5,
    name: "C615",
    description: "C/42",
    position: [6.369344, 2.487156],
    link: "/operations/dashboard/5",
  },
  {
    id: 6,
    name: "C147",
    description: "SOBETEX",
    position: [6.367326, 2.481597],
    link: "/operations/dashboard/6",
  },
  {
    id: 7,
    name: "C306",
    description: "LOT 67",
    position: [6.36405, 2.482518],
    link: "/operations/dashboard/7",
    isRed: true,
  },
  {
    id: 8,
    name: "C102",
    description: "KPOGBEMABOU",
    position: [6.363438, 2.471388],
    link: "/operations/dashboard/8",
    isRed: true,
  },
  {
    id: 9,
    name: "C188",
    description: "Hotel PLM",
    position: [6.35878, 2.461762],
    link: "/operations/dashboard/9",
  },
  {
    id: 10,
    name: "C304",
    description: "CFRAE",
    position: [6.362441, 2.461107],
    link: "/operations/dashboard/10",
  },
  {
    id: 11,
    name: "C290",
    description: "SIBIC",
    position: [6.367756, 2.471697],
    link: "/operations/dashboard/11",
    isRed: true,
  },
  {
    id: 17,
    name: "C363",
    description: "LOT109",
    position: [6.364349, 2.489321],
    link: "/operations/dashboard/17",
  },
  {
    id: 20,
    name: "C362",
    description: "FACE CEG LITTORAL",
    position: [6.365328, 2.493032],
    link: "/operations/dashboard/20",
  },
  {
    id: 21,
    name: "C359",
    description: "LOT112",
    position: [6.365046, 2.482518],
    link: "/operations/dashboard/21",
  },
  {
    id: 22,
    name: "C358",
    description: "LOT115",
    position: [6.363738, 2.478189],
    link: "/operations/dashboard/22",
  },
  {
    id: 24,
    name: "C119",
    description: "SOBEPEC",
    position: [6.364879, 2.46485],
    link: "/operations/dashboard/24",
  },
  {
    id: 31,
    name: "C025",
    description: "NO ADDRESS",
    position: [6.368362, 2.484064],
    link: "/operations/dashboard/31",
  },
  {
    id: 35,
    name: "C098",
    description: "NO ADDRESS (ROAD SIDE)",
    position: [6.36548, 2.461187],
    link: "/operations/dashboard/35",
  },
  {
    id: 36,
    name: "C070",
    description: "ZHEJIANG TANBEN TRANSFORMER",
    position: [6.361484, 2.463042],
    link: "/operations/dashboard/36",
  },
  {
    id: 40,
    name: "C132",
    description: "OFFICE NOTARIAL APPUIE LA SECURITE ALIMENTAIRE",
    position: [6.364777, 2.469224],
    link: "/operations/dashboard/40",
  },
  {
    id: 41,
    name: "C229",
    description: "SCIL BENIN",
    position: [6.365783, 2.467369],
    link: "/operations/dashboard/41",
  },
];

// export const mapResponseToLabelValue = (data: any) => {
//   return Object.entries(data).map(([label, value]) => ({
//     label: getLabelFromValue(label, data.currency),
//     value,
//   }));
// };

// export const getLabelFromValue = (value: string, currency: string) => {
//   switch (value) {
//     case "number_of_sites":
//       return "Number of Sites";
//     case "number_of_users":
//       return "Number of Users";
//     case "pending_alerts":
//       return "Pending Alerts";
//     case "total_revenue":
//       return `Total Revenue (${currency})`;
//     case "atc_losses":
//       return "ATC&C Losses";
//     case "total_amount":
//       return `Total Amount (${currency})`;
//     case "current_load":
//       return "Current Load (kW)";
//     case "total_consumption":
//       return "Total Consumption (kWh)";
//     case "avg_availability":
//       return "Avg. Availability (hrs)";
//     case "power_cuts":
//       return "Power Cuts (hrs)";
//     case "overloaded_dts":
//       return "Overloaded DTs";
//     case "reactive_power":
//       return "Reactive Power (kVAr)";
//     case "downtime_losses":
//       return `Downtime Losses (${currency})`;
//     case "tariff_losses":
//       return `Tariff Losses (${currency})`;
//     case "revenue_per_hour":
//       return `Revenue Per Hour (${currency}/hr)`;
//     case "distributed_electricity":
//       return "Distributed Electricity (kWh)";
//     case "year_of_production":
//       return "Year of Production";
//     case "asset_type":
//       return "Asset Type";
//     case "asset_capacity":
//       return "Asset Capacity (kVA)";
//     case "asset_position":
//       return "Asset Position";
//     case "power_factor":
//       return "Power Factor";
//     case "voltage_unbalance":
//       return "Voltage Unbalance (%)";
//     case "current_unbalance":
//       return "Current Unbalance (%)";
//     case "harmonic_distortion_phase_a":
//       return "Harmonic Distortion Phase A (%)";
//     case "harmonic_distortion_phase_b":
//       return "Harmonic Distortion Phase B (%)";
//     case "harmonic_distortion_phase_c":
//       return "Harmonic Distortion Phase C (%)";
//     case "voltage_phase_a":
//       return "Voltage Phase A (kV)";
//     case "voltage_phase_b":
//       return "Voltage Phase B (kV)";
//     case "voltage_phase_c":
//       return "Voltage Phase C (kV)";
//     case "current_phase_a":
//       return "Current Phase A (Amps)";
//     case "current_phase_b":
//       return "Current Phase B (Amps)";
//     case "current_phase_c":
//       return "Current Phase C (Amps)";
//     case "neutral_current":
//       return "Neutral Current (Amps)";
//     case "apparent_power":
//       return "Apparent Power (kVA)";
//     case "frequency":
//       return "Frequency (Hz)";

//     default:
//       return "Unknown";
//   }
// };

export const SMARTERISE_COMPANY_NAME =
  "Smarterise Integrated Solutions Limited";
export const companyServiceTypeOptions = [
  {
    key: "energy_monitoring",
    value: "energy_monitoring",
    label: "Energy monitoring",
  },
  {
    key: "distribution_electrique",
    value: "distribution_electrique",
    label: "Distribution electrique",
  },
];
export const countries = [
  { key: "United States", currency: "USD", value: "united_states" },
  { key: "Canada", currency: "CAD", value: "canada" },
  { key: "United Kingdom", currency: "GBP", value: "united_kingdom" },
  { key: "Nigeria", currency: "NGN", value: "nigeria" },
  { key: "Benin Republic", currency: "CFA", value: "benin_republic" },
  { key: "Germany", currency: "EUR", value: "germany" },
  { key: "India", currency: "INR", value: "india" },
  { key: "South Africa", currency: "ZAR", value: "south_africa" },
  { key: "Brazil", currency: "BRL", value: "brazil" },
  { key: "Japan", currency: "JPY", value: "japan" },
  { key: "Australia", currency: "AUD", value: "australia" },
];

export const companyTypeOptions = [
  { key: "car_energy", value: "car_energy", label: "Car energy" },
  { key: "utility", value: "utility", label: "Utility" },
];
export const assetTypeOptions = [
  { key: "transformer", value: "transformer", label: "Tranformer" },
  { key: "generator", value: "generator", label: "Generator" },
];
export const accessLevelsOptions = [
  { key: "operation", value: "operation", label: "Operation" },
  { key: "finance", value: "finance", label: "Finance" },
  { key: "manager", value: "manager", label: "Manager" },
  { key: "admin", value: "admin", label: "Admin" },
  { key: "other", value: "other", label: "Other" },
];

export const formatCurrency = (amount: number, locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const THRESHOLD = {
  transformer_load_rate: {
    grey: { min: 0, max: 0 },
    blue: { min: 0.1, max: 30 },
    deepGreen: { min: 31, max: 50 },
    lightGreen: { min: 51, max: 80 },
    yellow: { min: 81, max: 100 },
    orange: { min: 101, max: 120 },
    red: { min: 121, max: Infinity },
  },
  transformer_status: {
    // Boolean value, true is good (green), false is bad (red)
    green: true,
    grey: false,
  },
  voltage: {
    green: { min: 210, max: 230 },
    orange: { min: 200, max: 209, altMin: 231, altMax: 240 },
    red: { min: 0, max: 199, altMin: 241, altMax: Infinity },
  },
  frequency: {
    green: { min: 49.5, max: 50.5 },
    orange: { min: 48.5, max: 49.4, altMin: 50.6, altMax: 51.5 },
    red: { min: 0, max: 48.4, altMin: 51.6, altMax: Infinity },
  },
  power_factor: {
    green: { min: 0.9, max: 1.0 },
    orange: { min: 0.8, max: 0.89 },
    red: { min: 0, max: 0.79 },
  },
};

export function formatCustomDate(
  dateString: string,
  language: SupportedLocale = SupportedLocale.EN_US
): string {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  let formatted: string;

  try {
    formatted = date.toLocaleString(language || SupportedLocale.EN_US, options);
  } catch {
    formatted = date.toLocaleString(SupportedLocale.EN_US, options);
  }
  return formatted.replace("AM", "am").replace("PM", "pm");
}

export function formatCustomDateDayMonthYear(
  startDate: string,
  endDate: string,
  language: SupportedLocale = SupportedLocale.EN_US
): string {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
  };

  let formattedStart: string;
  let formattedEnd: string;

  try {
    formattedStart = start.toLocaleString(language, options);
    formattedEnd = end.toLocaleString(language, options);
  } catch (e) {
    console.log(`Unsupported locale: ${e} . Using default locale.`);
    // fallback to "en-US" if language is not supported
    formattedStart = start.toLocaleString(SupportedLocale.EN_US, options);
    formattedEnd = end.toLocaleString(SupportedLocale.EN_US, options);
  }

  return `${formattedStart} - ${formattedEnd}`;
}
export const createToolboxConfig = ({
  chartName = "Chart",
  time = "",
  right = "20px",
  top = "20px",
}) => {
  const baseOptions = {
    // toolbox with save as image feature
    toolbox: {
      feature: {
        saveAsImage: {
          title: "Save as Image",
          name: `${chartName}-${
            new Date().toISOString().split("T")[0]
          } - ${time}`,
          pixelRatio: 2,
        },
      },
      right,
      top,
    },
  };
  return baseOptions;
};
